// O QUE O PAINEL MOSTRA NO LUGAR DO CÓDIGO.
//
// A auditoria listava `auth.login`, `sessao.personificar`,
// `auth.senha_reidratada` — nomes que existem para o código, não para quem
// lê. Quem opera o painel precisa responder "o que essa pessoa fez?", e
// `sessao.personificar` não responde sem alguém explicar antes.
//
// O CÓDIGO CRU NÃO SOME: ele vai para o `title`, e o filtro continua
// aceitando `caixa.remover`. Traduzir e esconder o original tiraria de quem
// investiga a única coisa que dá para procurar no log do servidor.

/** Ações com nome próprio — as que a tradução por partes não acerta. */
const ACOES: Record<string, string> = {
  "auth.login": "Entrou",
  "auth.logout": "Saiu",
  "auth.refresh": "Renovou a sessão",
  "auth.2fa": "Usou verificação em duas etapas",
  "auth.2fa.ativar": "Ativou a verificação em duas etapas",
  "auth.2fa.desativar": "Desativou a verificação em duas etapas",
  "auth.2fa.confirmar": "Confirmou a verificação em duas etapas",
  "auth.senha_app.criar": "Criou uma senha de aplicativo",
  "auth.senha_app.remover": "Removeu uma senha de aplicativo",
  // O nome interno descreve o MECANISMO (o hash migrado virou Argon2id no
  // primeiro login). Para quem lê o painel, o que houve foi um login comum.
  "auth.senha_reidratada": "Entrou pela primeira vez (senha convertida)",
  "sessao.personificar": "Acessou como outro usuário",
  "caixa.senha": "Redefiniu a senha de uma caixa",
};

/** Objetos, para a tradução por partes. */
const OBJETOS: Record<string, string> = {
  caixa: "caixa",
  dominio: "domínio",
  revenda: "revenda",
  alias: "encaminhador",
  contato: "contato",
  filtro: "filtro",
  migracao: "migração",
  quarentena: "quarentena",
  correio: "mensagem",
  sessao: "sessão",
  auth: "acesso",
  licenca: "licença",
  bloqueio: "bloqueio",
  lista: "lista",
};

const VERBOS: Record<string, string> = {
  criar: "Criou",
  alterar: "Alterou",
  remover: "Removeu",
  salvar: "Salvou",
  enviar: "Enviou",
  responder: "Respondeu",
  liberar: "Liberou",
  descartar: "Descartou",
  enfileirar: "Enfileirou",
  cancelar: "Cancelou",
  publicar: "Publicou",
};

/**
 * O nome legível de uma ação da auditoria.
 *
 * Desconhecida volta como veio: inventar texto para código que ninguém
 * mapeou é pior que mostrar o código — o código ao menos é procurável.
 */
export function rotuloDaAcao(acao: string | null | undefined): string {
  const a = (acao ?? "").trim();
  if (!a) return "—";
  if (ACOES[a]) return ACOES[a]!;

  const partes = a.split(".");
  if (partes.length === 2) {
    const objeto = OBJETOS[partes[0]!];
    const verbo = VERBOS[partes[1]!];
    if (objeto && verbo) return `${verbo} ${objeto}`;
  }
  return a;
}

/** O nível de acesso, escrito como gente escreve. */
export function rotuloDoNivel(nivel: string | null | undefined): string {
  switch ((nivel ?? "").trim()) {
    case "usuario":
      return "Usuário";
    case "admin_dominio":
      return "Admin do domínio";
    case "revenda":
      return "Revenda";
    case "super_admin":
      return "Super admin";
    case "":
      return "—";
    default:
      return nivel!;
  }
}

/** O tipo de evento de entrega. `bounce` é inglês vazando para a tela. */
export function rotuloDoTipoDeEntrega(tipo: string): string {
  switch (tipo) {
    case "":
      return "tudo";
    case "entregue":
      return "entregue";
    case "adiado":
      return "adiado";
    case "rejeitado":
      return "rejeitado";
    case "bounce":
      return "devolvido";
    case "quarentena":
      return "quarentena";
    default:
      return tipo;
  }
}
